// extracted by mini-css-extract-plugin
export default {"addCardModal":"AddCard_addCardModal__JTOnP","closeModal":"AddCard_closeModal__BAdLE","header":"AddCard_header__xQsH0"};